import React from 'react';
import PropTypes from 'prop-types';

export default function BaseDialogLayoutHeader(props) {
  const { header, headerClassName } = props;

  if (!header) {
    return null;
  }

  return <header className={`base-dialog-layout-header-wrapper ${headerClassName}`}>{header}</header>;
}

BaseDialogLayoutHeader.propTypes = {
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  headerClassName: PropTypes.string,
};
